import React from 'react';

const StyleBackgroundSvg = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 193.01 130.79"
      {...props}
    >
      <path d="M185.15.5H7.85A7.37,7.37,0,0,0,.5,7.85v98.74A7.38,7.38,0,0,0,7.85,114H60.7c-5.48,6.92-13.32,14.86-21.32,16.34C61.17,128.67,78,122.39,88.2,114h97a7.38,7.38,0,0,0,7.36-7.36V7.85A7.38,7.38,0,0,0,185.15.5Z" />
    </svg>
  );
};

export default StyleBackgroundSvg;
